// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BLOG_COMMENT_REMOVE_COMPLAINT = "Zru\u0161 nahl\u00e1senie koment\u00e1ra";
export const COMMENT = "Koment\u00e1r";
export const COMPLAINTS_REPORTED_BY = "nahl\u00e1sila";
export const IMAGE = "Obr\u00e1zok";
export const IMAGE_REMOVE_COMPLAINTS = "Zru\u0161 nahl\u00e1senie obr\u00e1zka";
export const POST_COMPLAINTS_SUBTREE = "Nahl\u00e1senia v s\u00fa\u010dastiach pr\u00edspevku";
export const POST_REMOVE_COMPLAINTS_ALSO_POST_SUBTREE_COMPLAINTS = "Zru\u0161 nahl\u00e1senie pr\u00edspevku aj nahl\u00e1senia s\u00fa\u010dast\u00ed pr\u00edspevku";
export const POST_SUBTREE_REMOVE_COMPLAINTS = "Zru\u0161 nahl\u00e1senia s\u00fa\u010dast\u00ed pr\u00edspevku";
